const Particles = ({
    scale = 1
}: {
    scale?: number
}) => {
    return (
        <svg width={152 * scale} height={44 * scale} viewBox="0 0 152 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.4">
                <circle cx="4" cy="4" r="4" fill="#CCD4FF"/>
                <circle cx="16" cy="4" r="4" fill="#9AA9FF"/>
                <circle cx="28" cy="4" r="4" fill="#E6E9FF"/>
                <circle cx="40" cy="4" r="4" fill="#CCD4FF"/>
                <circle cx="52" cy="4" r="4" fill="#E6E9FF"/>
                <circle cx="64" cy="4" r="4" fill="#9AA9FF"/>
                <circle cx="76" cy="4" r="4" fill="#CCD4FF"/>
                <circle cx="88" cy="4" r="4" fill="#CCD4FF"/>
                <circle cx="100" cy="4" r="4" fill="#E6E9FF"/>
                <circle cx="112" cy="4" r="4" fill="#E6E9FF"/>
                <circle cx="124" cy="4" r="4" fill="#CCD4FF"/>
                <circle cx="136" cy="4" r="4" fill="#E6E9FF"/>
                <circle cx="148" cy="4" r="4" fill="#9AA9FF"/>
                <circle cx="16" cy="16" r="4" fill="#E6E9FF"/>
                <circle cx="28" cy="16" r="4" fill="#CCD4FF"/>
                <circle cx="40" cy="16" r="4" fill="#9AA9FF"/>
                <circle cx="52" cy="16" r="4" fill="#CCD4FF"/>
                <circle cx="64" cy="16" r="4" fill="#CCD4FF"/>
                <circle cx="76" cy="16" r="4" fill="#9AA9FF"/>
                <circle cx="88" cy="16" r="4" fill="#E6E9FF"/>
                <circle cx="100" cy="16" r="4" fill="#9AA9FF"/>
                <circle cx="112" cy="16" r="4" fill="#CCD4FF"/>
                <circle cx="124" cy="16" r="4" fill="#9AA9FF"/>
                <circle cx="136" cy="16" r="4" fill="#E6E9FF"/>
                <circle cx="148" cy="16" r="4" fill="#CCD4FF"/>
                <circle cx="16" cy="28" r="4" fill="#CCD4FF"/>
                <circle cx="40" cy="28" r="4" fill="#E6E9FF"/>
                <circle cx="52" cy="28" r="4" fill="#CCD4FF"/>
                <circle cx="64" cy="28" r="4" fill="#E6E9FF"/>
                <circle cx="88" cy="28" r="4" fill="#E6E9FF"/>
                <circle cx="100" cy="28" r="4" fill="#CCD4FF"/>
                <circle cx="112" cy="28" r="4" fill="#E6E9FF"/>
                <circle cx="136" cy="28" r="4" fill="#CCD4FF"/>
                <circle cx="40" cy="40" r="4" fill="#E6E9FF"/>
                <circle cx="64" cy="40" r="4" fill="#9AA9FF"/>
                <circle cx="100" cy="40" r="4" fill="#9AA9FF"/>
                <circle cx="136" cy="40" r="4" fill="#E6E9FF"/>
            </g>
        </svg>
    )
}

export default Particles
